// Why a confirm's credit check could not run (HFW on stop, Oct 2026). Mirrors
// TMSWeb.Common.Constants.CreditCheckNotRunReasons - the API sends the code, the UI words it.
export const CreditCheckNotRunReasons = {
  noAccountingConnection: 'NoAccountingConnection',
  packageNotSupported: 'PackageNotSupported',
  accountingUnavailable: 'AccountingUnavailable',
} as const;

// The reason as it reads inside M12, "The credit check could not be run: {reason}."
export function creditCheckNotRunReasonText(reason: string | undefined | null): string {
  switch (reason) {
    case CreditCheckNotRunReasons.noAccountingConnection:
      return $localize`there is no accounting connection`;
    case CreditCheckNotRunReasons.packageNotSupported:
      return $localize`the accounting package is not supported`;
    case CreditCheckNotRunReasons.accountingUnavailable:
      return $localize`the accounting package could not be reached`;
    default:
      // An unrecognised code shows as sent rather than leaving a gap in the sentence.
      return reason ?? '';
  }
}
